// VFX: Boho Orange Light Leak
// Category: overlays · Tags: light-leak, warm, boho, lifestyle, instagram
// Warm orange-to-pink light leak from corner — Instagram Reels and lifestyle content.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export default function BohoOrangeLightLeak() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const t = frame / durationInFrames;
  const fadeIn = interpolate(t, [0, 0.2], [0, 1], clamp);
  const fadeOut = interpolate(t, [0.7, 1], [1, 0], clamp);
  const op = Math.min(fadeIn, fadeOut);
  const drift = Math.sin(t * Math.PI * 2) * 80;
  const wobble = Math.cos(t * Math.PI * 3) * 40;
  return (
    <AbsoluteFill style={{ pointerEvents: "none", mixBlendMode: "screen", opacity: op }}>
      <div style={{
        position: "absolute",
        top: `${-20 + wobble}%`,
        right: `${-30 + drift}%`,
        width: "120%",
        height: "120%",
        background: "radial-gradient(circle, rgba(249,115,22,0.85) 0%, rgba(236,72,153,0.45) 40%, transparent 70%)",
        filter: "blur(60px)",
      }} />
      <div style={{
        position: "absolute",
        bottom: `${-10 - wobble}%`,
        left: `${-20 - drift}%`,
        width: "80%",
        height: "80%",
        background: "radial-gradient(circle, rgba(251,191,36,0.55) 0%, rgba(249,115,22,0.25) 40%, transparent 70%)",
        filter: "blur(80px)",
      }} />
      <div style={{
        position: "absolute", inset: 0,
        background: "linear-gradient(135deg, transparent 0%, rgba(249,115,22,0.1) 50%, rgba(236,72,153,0.15) 100%)",
      }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
